module.exports = __webpack_public_path__ + "static/background-image-s-6499d00b05740214604d2007b0ce5e7d.webm";